import { Box, TableCell, TableRow } from '@mui/material'
import FilterIcon from 'assets/FilterIcon'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

interface Props {
	handleReverseArray: () => void
}

export const MilkYieldHistoryTableHead = ({ handleReverseArray }: Props) => (
	<TableRow>
		<TableCell sx={{ width: '195px', pl: '8px' }}>
			<Box display='flex' gap='4px'>
				<TypographySecondary>Дата и время</TypographySecondary>
				<FilterIcon
					style={{ cursor: 'pointer' }}
					onClick={handleReverseArray}
				/>
			</Box>
		</TableCell>
		<TableCell sx={{ width: '100px', pl: '24px' }}>
			<TypographySecondary>Смена</TypographySecondary>
		</TableCell>
		<TableCell sx={{ width: '70%', pl: '24px' }}>
			<TypographySecondary>Надои, литр</TypographySecondary>
		</TableCell>
	</TableRow>
)
